import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RequestState } from '../../constants/request-state';
import { isRequestNone } from '../../utils';
import { cloManagersService } from '../../services/clo-managers.service';
import { cloManagerUsersActions } from '../../actions/entities/cloManagerUsers.actions';
import { AppState } from '../../types/state/AppState';

export function useCloManagerUsers(companyId?: number) {
    const dispatch = useDispatch();
    const { requestState, items } = useSelector((state: AppState) => state.entities.cloManagerUsers);

    useEffect(() => {
        if (isRequestNone(requestState)) {
            const doRequest = async () => {
                dispatch(cloManagerUsersActions.request(RequestState.request));
                try {
                    const users = await cloManagersService.getInvitedAndActiveManagers();
                    dispatch(cloManagerUsersActions.response(RequestState.success, users));
                } catch (e) {
                    dispatch(cloManagerUsersActions.request(RequestState.failure));
                }
            };

            doRequest();
        }
    }, [requestState, dispatch]);

    const filteredItems = useMemo(() => {
        if (companyId == null) return items;
        return Object.fromEntries(
            Object.entries(items).filter(([, u]) => u.companyId === companyId)
        ) as typeof items;
    }, [items, companyId]);

    return { requestState, items: filteredItems };
}
